import scenarioService from "../services/scenarios.service";

const state = () => ({
  directoryTree: {},
  isLoading: false,
});

const actions = {
  loadDirectoryTree({ commit }) {
    commit("setIsLoading", true);

    return new Promise((resolve) => {
      scenarioService
        .getDirectoryTree()
        .then((response) => {
          commit("setDirectoryTree", response.directories);
        })
        .finally(() => {
          commit("setIsLoading", false);
          resolve();
        });
    });
  },
};

const mutations = {
  setDirectoryTree(state, newTree) {
    state.directoryTree = newTree;
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
};

const getters = {
  isLoading: (state) => state.isLoading,
  directoryTree: (state) => state.directoryTree,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
